import Styles from './RotateSelectionForeground.module.scss'
import { RotateSelectionForegroundProps } from './Types'
import { track, useEditor, useSelectionEvents, useTransform } from '@tldraw/tldraw'
import { useRef } from 'react'
import { ArrowRefresh } from 'blaze-ui/icons'
import { getIsEditable, isOutsideFrame } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { useToolbarPlacement } from '../../Toolbars/ContextToolbar/useToolbarPlacement'
import { OFFSET, TOOLBAR_HEIGHT } from '../../Toolbars/ContextToolbar/constants'

const HANDLE_SIZE = 40

const RotateSelectionForeground = track(({ bounds, rotation }: RotateSelectionForegroundProps) => {
  const editor = useEditor()
  const events = useSelectionEvents('mobile_rotate')
  const { width, height } = bounds
  const ref = useRef<HTMLDivElement>(null)
  useTransform(ref, bounds.x, bounds.y, 1, rotation)
  const toolbarPlacement = useToolbarPlacement()

  const hide =
    editor.isInAny(
      'select.mask.idle',
      'select.mask.pointing_content',
      'select.mask.translating_content',
      'select.pointing_mask_handle',
      'select.masking',
    ) ||
    !getIsEditable(editor) ||
    editor.getSelectedShapes().some((s) => {
      return ['frame', 'video'].includes(s.type) || isOutsideFrame(editor, s)
    })

  if (hide) {
    return null
  }

  const cx = (width - HANDLE_SIZE) / 2
  const cy = toolbarPlacement === 'top' ? height : height + (TOOLBAR_HEIGHT + OFFSET) / editor.getZoomLevel()

  return (
    <div className="tl-overlays__item tl-selection__fg tl-html-context" data-testid="rotate-handle" ref={ref}>
      <div className={Styles.rotateHandle} {...events} style={{ translate: `${cx}px ${cy}px` }}>
        <ArrowRefresh size={20} />
      </div>
    </div>
  )
})

export { RotateSelectionForeground }
